import { Component, EventEmitter, Output } from '@angular/core';
import moment from 'moment';
import { xpoDateFormatter } from '../../../../../../formatters';
import { XpoConditionBase } from '../../../../validations/validations.class';
import { XpoFilterCondition } from '../../../condition';
import { IsBetweenModel } from '../../model.interface';
import { ordersMinMaxDate } from '../date.util';
import { filterFormats, Operators, OperatorText, XpoFilterConditionCriteria } from './../../../../../models';

@Component({
  templateUrl: './between.component.html',
  styleUrls: ['./between.component.scss'],
})
export class XpoConditionDateBetweenComponent extends XpoConditionBase implements XpoFilterCondition {
  static text: string = OperatorText.Between;
  static operator = Operators.Between;

  isNegative = false;
  model: IsBetweenModel = {
    from: '',
    to: '',
  };

  @Output() inputChanged = new EventEmitter();

  constructor() {
    super(filterFormats.stringRange);
  }

  validate(cellValue): boolean {
    // Do not validate if input is empty
    if (!this.model) {
      return true;
    }

    if (!cellValue) {
      return false;
    }

    const ordered = ordersMinMaxDate(this.model.from, this.model.to);
    return moment(cellValue)
      .startOf('day')
      .isBetween(moment(ordered.from).startOf('day'), moment(ordered.to).endOf('day'), null, '()');
  }

  getCriteria(): XpoFilterConditionCriteria {
    const ordered = ordersMinMaxDate(this.model.from, this.model.to);
    return {
      operator: Operators.Between,
      value: ordered.from,
      valueTo: ordered.to,
      display: xpoDateFormatter({ value: ordered.from }),
      displayTo: xpoDateFormatter({ value: ordered.to }),
    };
  }

  onInputChange(): any {
    this.validateFormat();
    this.inputChanged.emit(this.model);
  }
}
